import React from "react";

import ProviderButton, {
  ProviderButtonProps,
} from "@app/analytics/components/ProviderButton";
import type {
  ProviderId,
  SSOProviderId,
} from "@app/common/types/providerTypes";

import Button from "@rui/Button";
import { Row } from "@rui/Stack";

interface SignupClusterProps {
  onClickSignup: (
    e: React.MouseEvent,
    provider: SSOProviderId | "email"
  ) => void;
  onClickSignin: () => void;
}

const SignupButton = (props: ProviderButtonProps) => (
  <ProviderButton
    {...props}
    sx={{
      backgroundColor: "#fff",
      height: "36px",
      width: "36px",
      borderRadius: "8px",
      border: "none",
      boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.1)",
    }}
  />
);

const SignupCluster = ({
  onClickSignup,
  onClickSignin,
}: SignupClusterProps) => {
  const handleGenericSignup = (e: React.MouseEvent) => {
    onClickSignup(e, "email");
  };

  const handleSignin = () => {
    onClickSignin();
  };

  const handleClickSignup = (e: React.MouseEvent, providerId: ProviderId) => {
    onClickSignup(e, providerId as SSOProviderId);
  };

  return (
    <Row spacing="12px" alignItems="center">
      <Button
        variant="text"
        onClick={handleSignin}
        sx={{ color: "shades.neutral.600", px: "18px" }}
      >
        Sign in
      </Button>
      <Row
        sx={{
          backgroundColor: "shades.secondary.50",
          padding: "8px",
          borderRadius: "12px",
          flexGrow: 0,
          width: "286px",
        }}
        spacing={1}
      >
        <Button
          variant="gradient"
          sx={{ height: "36px", flexShrink: 0 }}
          onClick={handleGenericSignup}
        >
          Sign up for free
        </Button>
        <SignupButton
          providerId="google"
          variant="icon"
          onClick={handleClickSignup}
        />
        <SignupButton
          providerId="microsoft_graph"
          variant="icon"
          onClick={handleClickSignup}
        />
        <SignupButton
          providerId="zoom"
          variant="icon"
          onClick={handleClickSignup}
        />
      </Row>
    </Row>
  );
};

export default SignupCluster;
